/* Dependencies */
import styled from 'styled-components';

export const EmptyList = styled.div.attrs(() => ({
  className: 'SettingsClassroomDetailsListEmptyState',
}))`
  display: flex;
  align-items: center;
  justify-content: center;

  color: ${({ theme }) => theme.colors.shadeMediumDark};
  font-size: 16px;
  margin: 100px auto;
`;
